

















































































































import { Component, Emit, Model, Prop, Vue, Watch } from 'vue-property-decorator'
import {
    Column,
    DateTimeRange,
    EventDetail,
    Form,
    FormType,
    InputType,
    QueryParam
} from '@/api/model/DefaultPageEntity'
import { UtilsIndex } from '@/utils'
import DefaultColumnItem from '@/components/common/DefaultColumnItem.vue'

@Component({ components: { DefaultColumnItem } })
export default class DefaultVuePage extends Vue {
        name = 'default-vue-page';
        @Prop({ default: '' })
        labelWidth!: string; // 表单标题的宽度
        @Prop()
        rules!: any;// 表单规则
        @Prop({ default: () => [] })
        columns!: Array<Column>;// 列表生成的配置项
        @Prop({ default: () => [] })
        forms!: Array<Form>;// 表单生成的配置项
        @Prop({ default: () => [] })
        list!: Array<any>;// 实际用到的列表数据
        @Prop({ default: 0 })
        total!: number;// 列表最大条数
        @Prop({ default: true })
        selection!: boolean; // 列表是否需要多选
        @Prop({ default: true })
        showTable!: boolean;// 是否显示列表
        @Prop({ default: false })
        formDisabled!: boolean;// 表单是否禁用
        @Model('formChanged', { default: () => ({}) })
        formData!: any;// 表单项填充数据
        @Prop({ default: true })
        showButton!: boolean;// 是否需要显示默认的重置 和 查询按钮
        @Prop({ default: () => ({}) })// 有时候需要从外部传递参数给列表查询需要合并这些参数
        externalParam!: any;
        @Prop({ default: false })
        refresh!: boolean;
        @Prop({ default: true })
        isLoadListImmediately!: boolean;
        @Prop({ default: true })
        inline!: boolean;
        @Prop({ default: -1 })
        columnNum!: number;
        @Prop({ default: true })
        tableLoading!: number;
        private selectArray: Array<any> = [];
        pageSize = 10;
        currentPage = 1;
        form: any = {};
        FormType = FormType;

        mounted() {
            // console.log(this.columnNum)
        }

        @Watch('refresh')
        onRefresh(value: boolean) {
            if (value) {
                this.getList()
                this.$emit('update:refresh', false)
            }
        }

        @Emit('onColumnEvent')
        onColumnEvent(detail: EventDetail): EventDetail {
            return detail
        }

        // 强制处理输入格式
        input(e: any, formProp: string, inputType: InputType) {
            if (inputType) {
                switch (inputType) {
                    case InputType.MONEY:
                        this.form[formProp] = UtilsIndex.clearNoNum(e)
                        break
                    case InputType.NUM || InputType.MOBILE:
                        this.form[formProp] = e.replace(/[^\d]/g, '')
                        break
                }
            }
        }

        get isOneSelect() {
            return this.selectArray.length === 1
        }

        get isSelect() {
            return this.selectArray.length > 0
        }

        reset(form: string) {
            (this.$refs[form] as any).resetFields()
            this.form = {}
            this.getList()
        }

        created() {
            this.initForm(this.forms)
            this.initFormData(this.formData)

            if (this.isLoadListImmediately) {
                this.getList()
            }
        }

        public validate(callback: any): void {
            (this.$refs.form as any).validate((valid: boolean) => {
                if (valid) {
                    callback()
                } else {
                    return false
                }
            })
        }

        submit(form: string) {
            this.currentPage = 1;
            (this.$refs[form] as any).validate((valid: boolean) => {
                if (valid) {
                    this.getList()
                } else {
                    return false
                }
            })
        }

        @Emit('selectionChange')
        selectionChange(selectArray: Array<any>) {
            this.selectArray = selectArray
            return selectArray
        }

        handleSizeChange(pageSize: number) {
            this.pageSize = pageSize
            this.getList()
        }

        handleCurrentChange(currentPage: number) {
            this.currentPage = currentPage
            this.getList()
        }

        @Watch('forms')
        onFormsChanged(newVal: Array<Form>, oldVal: Array<Form>) {
            this.initForm(newVal)
        }

        @Emit('onSubmit')
        getList(): QueryParam {
            return this.getParams()
        }

        getParams() {
            return {
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                ...UtilsIndex.mergeData2({}, this.handleParams()),
                ...this.externalParam
            }
        }

        private handleParams() {
            let param: any = {}
            for (let formKey in this.form) {
                // 处理日期格式
                let dateTimeRangesForms: Form[] = this.forms.filter((form: Form) => {
                    return form.formType === FormType.DATE_TIMERANGE && form.dateTimeRange && form.prop === formKey
                })
                if (dateTimeRangesForms.length > 0) {
                    for (let dateTimeRangesForm of dateTimeRangesForms) {
                        try {
                            let dateTimeRange: DateTimeRange = dateTimeRangesForm.dateTimeRange as DateTimeRange
                            let startTime = this.form[formKey][0]
                            let endTime = this.form[formKey][1]
                            param[dateTimeRange.startTimeKey] = dateTimeRange.isTimestamp
                                ? new Date(startTime.replace(new RegExp('-', 'gm'), '/')).getTime() : startTime
                            param[dateTimeRange.endTimeKey] = dateTimeRange.isTimestamp
                                ? new Date(endTime.replace(new RegExp('-', 'gm'), '/')).getTime() : endTime
                        } catch (e) {
                        }
                    }
                } else {
                    param[formKey] = this.form[formKey]
                }
            }
            return param
        }

        /**
         * 初始化表单对象
         * @param newVal
         */
        initForm(newVal: Array<Form>) {
            // console.log('initForm')
            if (!newVal) {
                return
            }
            let newForm: any = {}
            newVal.map((item: Form, index: number) => {
                newForm[item.prop] = this.form[item.prop]
                if (item.value) {
                    newForm[item.prop] = item.value
                }
                // 异步拉取select
                if (item.formType === FormType.SELECT && item.querySelects !== undefined) {
                    (item as any).querySelects(item, (selects: any[]) => {
                        item.selects = selects
                    })
                }

                // 异步拉取级联数据
                if (item.formType === FormType.CASCADER && item.queryCascadeOptions !== undefined) {
                    (item as any).queryCascadeOptions(item, (options: any[]) => {
                        item.options = options
                    })
                }
            })
            this.form = newForm
        }

        @Watch('formData', { deep: true })
        onFormDataChanged(newVal: any, oldVal: any) {
            this.initFormData(newVal)
        }

        private initFormData(newVal: any) {
            for (let formKey in this.form) {
                this.form[formKey] = newVal[formKey] === null || newVal[formKey] === undefined ? '' : newVal[formKey]
            }
        }

        @Watch('form', { deep: true })
        onFormChanged(newVal: any) {
            this.$emit('formChanged', newVal)
        }
}
